"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ProfilePrivacyOutlineYes = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ProfilePrivacyOutlineYes_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm0-1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.452 11.08C1.424 11.718 1 12.487 1 13.2A1.8 1.8 0 0 0 2.8 15h5.873a6.46 6.46 0 0 0 1.131 1H2.8A2.8 2.8 0 0 1 0 13.2C0 10.887 2.784 9.01 6.964 9a10.634 10.634 0 0 0-.05 1c-1.922.013-3.447.45-4.462 1.08Z",
    fill: "#000001"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ProfilePrivacyOutlineYes_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#131619",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon_ProfilePrivacyOutlineYes_".concat(randomId, "_b"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 9,
    height: 9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.248 8.886c-.15-.002-.287.1-.3.241-.399 4.337 2.158 6.29 3.976 6.798a.105.105 0 0 0 .058 0c1.819-.508 4.375-2.461 3.976-6.798-.013-.142-.15-.243-.3-.241-1.404.014-2.89-1.254-3.462-1.797a.376.376 0 0 0-.486 0c-.571.543-2.058 1.81-3.462 1.797Z",
    fill: "#3B90F7"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ProfilePrivacyOutlineYes_".concat(randomId, "_b)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3B90F7",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ProfilePrivacyOutlineYes;
exports["default"] = _default;